import React from 'react';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import PurchaseDocumentForm from './forms/PurchaseDocumentForm';
import { PurchaseDocumentServiceManifestDataForm } from '../../../app/models/PurchaseDocument';
import { Society } from '../../../app/models/Society';
import { Provider } from '../../../app/models/Provider';


interface Props {
    fetching?: boolean;
    action: () => void;
    cancel: () => void;
    purchaseDocument: any;
    setPurchaseDocument: (purchaseDocument: any) => void;
    availableStatuses: PurchaseDocumentServiceManifestDataForm[];  
    errorFields?: any;
    updated: boolean;
    disabled: boolean;
    societies: Society[];
    providers: Provider[];
    loadingProvider?: boolean;
    loadingServiceManifestStatus?: boolean;
  }

const PurchaseDocumentFormContainer = ({
    fetching,
    action,
    cancel,
    purchaseDocument,
    setPurchaseDocument,
    availableStatuses,
    updated = false,
    disabled= false,
    errorFields = null,
    societies,
    providers,
    loadingProvider,
    loadingServiceManifestStatus
}: Props) => {
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <PurchaseDocumentForm
                        purchaseDocument={purchaseDocument}
                        setPurchaseDocument={setPurchaseDocument}
                        societies={societies}
                        providers={providers}
                        availableStatuses={availableStatuses}  
                        errorFields={errorFields}
                        disabled={updated}
                        loadingProvider={loadingProvider}
                        loadingServiceManifestStatus={loadingServiceManifestStatus}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetching} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={action} locked={fetching} />
                </div>
            </div>
        </>
    );
};

export default PurchaseDocumentFormContainer;
